var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _class, _class2, _descriptor, _descriptor2, _descriptor3;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

/*!
 * @copyright
 * Copyright(c) 2019 SICK AG
 */
import { classMap, Component, html, nothing, Prop, Watch } from '@sick-davinci/ce-decorators';
import { style } from './FlyoutMenu.style';
import { Icon } from '../icon/Icon';
import { FlyoutMenuItem } from './flyout-menu-item/FlyoutMenuItem';
/**
 * A `davinci-flyout-menu` displays a menu in form of a button that opens a sub menu with an arbitrary number of `davinci-flyout-menu-item`.
 *
 * @example
 * ```html
 * <davinci-flyout-menu>
 *  <davinci-flyout-menu-item label="settings"></davinci-flyout-menu-item>
 *  <davinci-flyout-menu-item label="language"></davinci-flyout-menu-item>
 *  <davinci-flyout-menu-item label="user"></davinci-flyout-menu-item>
 * </davinci-flyout-menu>
 * ```
 * @slot {davinci-flyout-menu-item[]} list of sub menus
 */

export let FlyoutMenu = (_dec = Component({
  tag: 'davinci-flyout-menu',
  style,
  // tslint:disable-line:no-unsafe-any
  dependencies: [Icon]
}), _dec2 = Prop({
  type: Boolean
}), _dec3 = Prop({
  type: String
}), _dec4 = Reflect.metadata("design:type", String), _dec5 = Prop({
  type: String
}), _dec6 = Reflect.metadata("design:type", String), _dec7 = Watch('open'), _dec8 = Reflect.metadata("design:paramtypes", [Boolean, Boolean]), _dec(_class = (_class2 = class FlyoutMenu extends FlyoutMenuItem {
  constructor(...args) {
    super(...args);

    _initializerDefineProperty(this, "externalControl", _descriptor, this);

    _initializerDefineProperty(this, "icon", _descriptor2, this);

    _initializerDefineProperty(this, "iconSrc", _descriptor3, this);

    _defineProperty(this, "_mutationObserver", new MutationObserver(() => this._setVerticalFlyoutPosition()));
  }

  componentConnected() {
    this._mutationObserver.observe(this, {
      attributeFilter: ['style']
    });
  }

  componentDidRender() {
    this._setVerticalFlyoutPosition();
  }

  render() {
    return html`
      ${[this._renderClickCatcher(), this._renderButton(), this.renderSubmenu()]}
    `;
  }

  renderSubmenu() {
    return this.open ? html`<div class="menu" @menu-click="${this._toggleMenu}">
        <div class="inner-container">
          ${super.renderSubMenu()}
        </div>
      </div>` : nothing;
  }

  onOpenChanges(_, newValue) {
    if (this.externalControl && !newValue) {
      this.closeSubmenuesRecursively(this);
    }
  }

  _renderButton() {
    if (this.externalControl) {
      return html``;
    }

    if (!!this.iconSrc) {
      return html`<davinci-icon-ref
        class="menu-button"
        src="${this.iconSrc}"
        @click="${this._toggleMenu}"
      ></<davinci-icon-ref>`;
    } else if (!!this.icon) {
      return html`<davinci-icon
        class="menu-button"
        icon="${this.icon}"
        @click="${this._toggleMenu}"
      ></davinci-icon>`;
    } else {
      return html``;
    }
  }

  _renderClickCatcher() {
    if (this.externalControl) {
      return html``;
    }

    const classes = {
      'click-catcher': true,
      'active': this.open
    };
    return html`
      <div class="${classMap(classes)}" @click="${this._toggleMenu}"></div>`;
  }

  _toggleMenu() {
    this.open = !this.open;

    if (!this.open) {
      this.closeSubmenuesRecursively(this);
    }
  }

  _setVerticalFlyoutPosition() {
    if (!this.open || this.externalControl) {
      return;
    }

    const defaults = {
      hostWidth: 24,
      hostHeight: 19.5,
      sideOffset: 5,
      topOffset: 40
    };
    const menuEl = this.shadowRoot.querySelector('.menu');
    const hostWidth = this.getBoundingClientRect().width;
    const hostHeight = this.getBoundingClientRect().height;
    const side = this.getAttribute('left') ? 'left' : 'right';
    menuEl.style[side] = hostWidth / 2 - defaults.hostWidth / 2 - defaults.sideOffset + 'px';
    menuEl.style.top = hostHeight - defaults.hostHeight + defaults.topOffset + 'px';
  }

}, (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "externalControl", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "icon", [_dec3, _dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 'navigation/more_vert';
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "iconSrc", [_dec5, _dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _applyDecoratedDescriptor(_class2.prototype, "onOpenChanges", [_dec7, _dec8], Object.getOwnPropertyDescriptor(_class2.prototype, "onOpenChanges"), _class2.prototype)), _class2)) || _class);
